import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { RoomTypeTableColumn } from "./RoomTypeTableColumn";

import { useRoomTypesList } from "@hooks/inventory/roomConfiguration/useRoomTypesList";

import { TablePagination } from "@helpers/tablePagination";

import { Pagination } from "@type/inventory/pagination";
import { RoomTypesResponseType } from "@type/inventory/room-types";

type RoomTypeListTablePropType = {
  handleQueryById: (id: string | number) => void;
  handleScrollToTop: () => void;
};

export default function RoomTypeListTable({
  handleQueryById,
  handleScrollToTop,
}: RoomTypeListTablePropType) {
  const { t } = useTranslation();

  const { handleQuery, roomConfigRoomTypesState } = useRoomTypesList();
  const { getData, createSuccess, updateSuccess } = roomConfigRoomTypesState;

  const { data, pagination } = getData || ({} as RoomTypesResponseType);
  const { total } = pagination || ({} as Pagination);

  useEffect(() => {
    if (createSuccess === true || updateSuccess === true)
      handleQuery("page", 1);
  }, [createSuccess, updateSuccess, handleQuery]);

  return (
    <div className="pt-12 border-top">
      <Table
        header={{
          title: t("INVENTORY_ROOM_CONFIG.ROOM_TYPE.HEADER"),
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },
        }}
        columns={RoomTypeTableColumn(t, handleScrollToTop, handleQueryById)}
        // remove={{
        //   customIcon: <IconEdit01 size={24} />,
        //   onClick: (id) => {
        //     handleScrollToTop();
        //     handleQueryById(id);
        //   },
        // }}
        rows={data || []}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
}
